var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJmlLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-container",
    viewBox: "0 0 311 190",
    width: 50,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "JMLathamLogo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "l-path",
    d: "M210 1 l13 0 l9 9 l0 123 l59 0 l9 9 l0 12 l-9 9 l-81 0 l-9 -9 l0 -144 z",
    style: {
      stroke: "rgba(20, 20, 20, 1)",
      strokeWidth: 1,
      fill: "rgba(0, 0, 82, 1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "m-path",
    d: "M105 1 l52 52 l53 -52 l13 0 l 9 9 l0 13 l-75 75 l-75 -75 l0 -13 l9 -9 l13 0 z",
    style: {
      stroke: "rgba(20, 20, 20, 1)",
      strokeWidth: 1,
      fill: "rgba(206, 210, 215, 1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "j-path",
    d: "M92 1 l13 0 l9 9 l0 144 l-9 9 l-91 0 l-9 -9 l0 -34 l9 -9 l13 0 l9 9 l0 13 l46 0 l0 -123 l9,-9 z",
    style: {
      stroke: "rgba(20, 20, 20, 1)",
      strokeWidth: 1,
      fill: "rgba(164, 23, 32, 1)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "j-top"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 86,
    cy: 12,
    style: {
      stroke: "rgba(20, 20, 21, 1)",
      strokeWidth: 1,
      fill: "rgba(206, 210, 215, .8)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 92,
    cy: 5,
    style: {
      stroke: "rgba(20, 20, 21, 1)",
      strokeWidth: 1,
      fill: "rgba(206, 210, 215, .8)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 103,
    cy: 5,
    style: {
      stroke: "rgba(20, 20, 21, 1)",
      strokeWidth: 1,
      fill: "rgba(206, 210, 215, .8)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 110,
    cy: 12,
    style: {
      stroke: "rgba(20, 20, 21, 1)",
      strokeWidth: 1,
      fill: "rgba(206, 210, 215, .8)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "j-toe"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 9,
    cy: 122,
    style: {
      stroke: "rgba(20, 20, 21, 1)",
      strokeWidth: 1,
      fill: "rgba(206, 210, 215, .8)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 15,
    cy: 115,
    style: {
      stroke: "rgba(20, 20, 21, 1)",
      strokeWidth: 1,
      fill: "rgba(206, 210, 215, .8)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 26,
    cy: 115,
    style: {
      stroke: "rgba(20, 20, 21, 1)",
      strokeWidth: 1,
      fill: "rgba(206, 210, 215, .8)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 33,
    cy: 122,
    style: {
      stroke: "rgba(20, 20, 21, 1)",
      strokeWidth: 1,
      fill: "rgba(206, 210, 215, .8)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "l-toe"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 289,
    cy: 137,
    style: {
      stroke: "rgba(20, 20, 21, 1)",
      strokeWidth: 1,
      fill: "rgba(206, 210, 215, .8)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 296,
    cy: 143,
    style: {
      stroke: "rgba(20, 20, 21, 1)",
      strokeWidth: 1,
      fill: "rgba(206, 210, 215, .8)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 296,
    cy: 153,
    style: {
      stroke: "rgba(20, 20, 21, 1)",
      strokeWidth: 1,
      fill: "rgba(206, 210, 215, .8)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 289,
    cy: 159,
    style: {
      stroke: "rgba(20, 20, 21, 1)",
      strokeWidth: 1,
      fill: "rgba(206, 210, 215, .8)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "l-top"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 212,
    cy: 5,
    style: {
      stroke: "rgba(20, 20, 21, 1)",
      strokeWidth: 1,
      fill: "rgba(206, 210, 215, .8)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 221,
    cy: 5,
    style: {
      stroke: "rgba(20, 20, 21, 1)",
      strokeWidth: 1,
      fill: "rgba(206, 210, 215, .8)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 228,
    cy: 12,
    style: {
      stroke: "rgba(20, 20, 21, 1)",
      strokeWidth: 1,
      fill: "rgba(206, 210, 215, .8)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    cx: 228,
    cy: 21,
    style: {
      stroke: "rgba(20, 20, 21, 1)",
      strokeWidth: 1,
      fill: "rgba(206, 210, 215, .8)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadow-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shadow-1.1",
    d: "M14 163 l10 10 l90 0 l10 -10 l0 -98 l-10 -10 l0 99 l-9 9 z",
    style: {
      stroke: "rgba(20, 20, 20, 1)",
      strokeWidth: 1,
      fill: "rgba(156, 160, 165, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadow-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shadow-2.1",
    d: "M210 163 l10 10 l80 0 l10 -10 l0 -11 l-10 -10 l0 12 l-9 9 z",
    style: {
      stroke: "rgba(20, 20, 20, 1)",
      strokeWidth: 1,
      fill: "rgba(156, 160, 165, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadow-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shadow-1.1",
    d: "M157 98 l10 10 l34 -34 l0 -20 z",
    style: {
      stroke: "rgba(20, 20, 20, 1)",
      strokeWidth: 1,
      fill: "rgba(156, 160, 165, 1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadow-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shadow-2.1",
    d: "M232 10 l10 10 l0 113 l-10 0 z",
    style: {
      stroke: "rgba(20, 20, 20, 1)",
      strokeWidth: 1,
      fill: "rgba(156, 160, 165, 1)"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJmlLogo);
export default __webpack_public_path__ + "static/media/jml_logo.b21c394145e91c55ca63aa8aa58cc72c.svg";
export { ForwardRef as ReactComponent };